<template>
  <div>
    <div
      class="cxm-Tooltip-Slot"
      @mouseover="getTooltipPosition"
    >
      <slot />
    </div>
    <div
      v-if="text || html"
      ref="tooltip"
      class="cxm-Tooltip"
      :class="[position]"
      :style="style"
    >
      <div
        v-if="text"
        class="cxm-Tooltip-Text"
      >
        {{ subtext }}
        {{ text }}
      </div>
      <div
        v-else
        v-html="html"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    subtext: {
      type: String,
      default: '',
    },
    html: {
      type: String,
      default: '',
    },
    background: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '#ffffff',
    },
    position: {
      type: String,
      default: 'top left',
    },
    width: {
      type: String,
      default: 'auto',
    },
  },
  data() {
    return {
      left: 0,
      top: 0,
    };
  },
  computed: {
    style() {
      return {
        background: this.background,
        color: this.color,
        'max-width': this.width,
        '--left': `${this.left}px`,
        '--top': `${this.top}px`,
      };
    },
  },
  methods: {
    getTooltipPosition() {
      if (
        !this.$slots.default
        || !this.$slots.default[0]
        || !this.$slots.default[0].elm
      ) {
        return { left: 0, top: 0 };
      }
      try {
        const el = this.$slots.default[0].elm;
        let rect = null;
        if (typeof el !== HTMLElement) {
          const range = document.createRange();
          range.selectNode(el);
          rect = range.getBoundingClientRect();
        } else {
          rect = el.getBoundingClientRect();
        }

        const { tooltip } = this.$refs;
        if (!tooltip) {
          return { left: 0, top: 0 };
        }
        const tooltipRect = tooltip.getBoundingClientRect();
        const extraSpacing = 4;

        if (this.position.includes('top')) {
          this.top = rect.top - tooltipRect.height - extraSpacing;
        }
        if (this.position.includes('bottom')) {
          this.top = rect.top + rect.height + extraSpacing;
        }
        if (this.position.includes('middle')) {
          this.top = rect.top + rect.height / 2 - tooltipRect.height / 2;
        }
        if (this.position.includes('left')) {
          this.left = rect.left - tooltipRect.width - extraSpacing;
        }
        if (this.position.includes('right')) {
          this.left = rect.left + rect.width + extraSpacing;
        }
        if (this.position.includes('center')) {
          this.left = rect.left + (rect.width / 2 - tooltipRect.width / 2);
        }
      } catch (error) {
        return { left: 0, top: 0 };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cxm-Tooltip {
  background: var(--track-color-bluegray-90);
  border-radius: 2px;
  color: var(--track-color-white);
  font-size: var(--track-font-size-xxs);
  font-weight: var(--track-font-weight-medium);
  left: var(--left);
  line-height: var(--track-line-height-compact);
  opacity: 0;
  padding: var(--track-spacing-sm);
  position: fixed;
  top: var(--top);
  transition: visibility 0s, opacity 0.5s;
  visibility: hidden;
  z-index: 999999;

  .cxm-Tooltip-Slot:hover ~ & {
    opacity: 1;
    visibility: visible;
  }
}

.cxm-Tooltip-Text {
  position: relative;
  white-space: initial;
}
</style>
